/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/nextjs';

class Logger {
  debug(message: string, ...params: any) {
    console.debug(`[Debug] ${message}`, ...params);
    Sentry.captureMessage(message, Sentry.Severity.Debug);
  }

  info(message: string, ...params: any) {
    console.log(`[Info] ${message}`, ...params);
    Sentry.captureMessage(message, Sentry.Severity.Info);
  }

  warn(message: string, ...params: any) {
    console.warn(`[Warn] ${message}`, ...params);
    Sentry.captureMessage(message, Sentry.Severity.Warning);
  }

  error(message: string, ...params: any) {
    console.error(`[Error] ${message}`, ...params);
    Sentry.captureException(message);
  }

  fatal(message: string, ...params: any) {
    console.error(`[Fatal] ${message}`, ...params);
    Sentry.captureException(message);
  }
}

export default new Logger();
